
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ATIVAÇÃO VITAL PARA MOBILE: Permite que o app seja instalado (PWA)
serviceWorkerRegistration.register();
